import { LIST_ITEMS_HEIGHT } from 'components/select/constants';
import styled from 'styled-components';

const ListItemsWrapper = styled.div<{ matchInnerSearch?: boolean }>`
    max-height: ${LIST_ITEMS_HEIGHT};
    overflow-y: auto;
`;

export { ListItemsWrapper };
